import { render, staticRenderFns } from "./SportsDefaultFooter.vue?vue&type=template&id=ca207bac&scoped=true"
import script from "./SportsDefaultFooter.vue?vue&type=script&lang=ts"
export * from "./SportsDefaultFooter.vue?vue&type=script&lang=ts"
import style0 from "./SportsDefaultFooter.vue?vue&type=style&index=0&id=ca207bac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca207bac",
  null
  
)

export default component.exports